import axios from "@/config/axios.config";

import yqkApi from "@/api/yqk";
// 消费交易流水列表
export function transLists(data, noLoading = false) {
	return axios({
		method: "post",
		url: yqkApi.transListsUrl,
		data,
		noLoading,
	});
}

// 充值交易流水列表
export function rechargeLists(data, noLoading = false) {
	return axios({
		method: "post",
		url: yqkApi.rechargeListsUrl,
		data,
		noLoading,
	});
}

// 绑定园区卡
export function bindCard(data) {
	return axios({
		method: "post",
		url: yqkApi.bindUrl,
		data,
	});
}

// 解绑园区卡
export function removebindCard(data) {
	return axios({
		method: "post",
		url: yqkApi.removeBindUrl,
		data,
	});
}

// 生成付款码
export function createPayQrcode(data) {
	return axios({
		method: "post",
		url: yqkApi.createPayQrcodeUrl,
		data,
	});
}
// 园区卡管理
export function cardManage(data) {
	return axios({
		method: "post",
		url: yqkApi.cardManageUrl,
		data,
	});
}

// 园区卡是否可用于支付
export function getCardPay(data, noLoading = false) {
	return axios({
		method: "post",
		url: yqkApi.getCardPayUrl,
		data,
		noLoading
	});
}